import { tv } from 'tailwind-variants'

import { COLOR } from '@ui-kit/constants'

export const textColor = tv({
  base: 'text-black',
  variants: {
    color: {
      white: 'text-white',
      black: 'text-black',

      paleSpring: 'text-pale-spring',
      paleSpringLight: 'text-pale-spring-light',
      paleSpringDark: 'text-pale-spring-dark',

      safepointsGreenLight: 'text-safepoints-green-light',

      deepForest: 'text-deep-forest',
      deepForestLight: 'text-deep-forest-light',
      deepForestDark: 'text-deep-forest-dark',

      success: 'text-success',
      successLight: 'text-success-light',
      successDark: 'text-success-dark',

      error: 'text-error',
      errorLight: 'text-error-light',
      errorDark: 'text-error-dark',

      warning: 'text-warning',
      warningLight: 'text-warning-light',
      warningDark: 'text-warning-dark',

      grey100: 'text-grey-100',
      grey200: 'text-grey-200',
      grey300: 'text-grey-300',
      grey400: 'text-grey-400',
      grey500: 'text-grey-500',
      grey600: 'text-grey-600',
      grey700: 'text-grey-700',

      brandDark: 'text-brand-dark',
      brandDarkTransparent: 'border-brand-dark-50',
      brandLight: 'text-brand-light',
      brandLime: 'text-brand-lime',
      uiDark: 'text-ui-dark',
      uiDarkMedium: `text-ui-dark/70`,
      uiDarkDisabled: `text-ui-dark/30`,
      uiLight: 'text-ui-light',
      uiLightMedium: `text-ui-light/70`,
      uiLightDisabled: `text-ui-light/30`,
      uiGreyDark: 'text-ui-grey',
      uiGreyMedium: 'text-ui-grey-500',
      uiGreyLight: 'text-ui-grey-50',
      uiGrayUltralight: 'text-ui-grey-ultra-light',
      uiGreen: 'text-ui-green',
      uiGreenLight: 'text-ui-green-light',
      uiGreenOverlay: 'text-ui-green-overlay',
      uiGreenMuted: 'text-ui-green-500',
      uiRed: 'text-ui-red',
      uiRedLight: 'text-ui-red-light',
      uiRedMuted: 'text-ui-red-500',
      uiOrange: 'text-ui-orange',
      uiOrangeLight: 'text-ui-orange-light',
      uiOrangeMuted: 'text-ui-orange-500',
      blueSky: 'text-blue-sky',
      playground1Dark: 'text-playground1-dark',
      playground1Light: 'text-playground1-light',
      playground2Dark: 'text-playground2-dark',
      playground2Light: 'text-playground2-light',
      playground3Dark: 'text-playground3-dark',
      playground3Light: 'text-playground3-light',
      playground4Dark: 'text-playground4-dark',
      playground4Light: 'text-playground4-light',
      playground5Dark: 'text-playground5-dark',
      playground5Light: 'text-playground5-light',
      playground6Dark: 'text-playground6-dark',
      playground6Light: 'text-playground6-light',
      whatsapp: 'text-whatsapp',
      transparent: 'text-transparent',
      backdrop: `text-[${COLOR.backdrop}]`,
    },
  },
})

export const bgColor = tv({
  variants: {
    color: {
      white: 'bg-white',
      black: 'bg-black',

      paleSpring: 'bg-pale-spring',
      paleSpringLight: 'bg-pale-spring-light',
      paleSpringDark: 'bg-pale-spring-dark',

      safepointsGreenLight: 'bg-safepoints-green-light',

      deepForest: 'bg-deep-forest',
      deepForestLight: 'bg-deep-forest-light',
      deepForestDark: 'bg-deep-forest-dark',

      success: 'bg-success',
      successLight: 'bg-success-light',
      successDark: 'bg-success-dark',

      error: 'bg-error',
      errorLight: 'bg-error-light',
      errorDark: 'bg-error-dark',

      warning: 'bg-warning',
      warningLight: 'bg-warning-light',
      warningDark: 'bg-warning-dark',

      grey100: 'bg-grey-100',
      grey200: 'bg-grey-200',
      grey300: 'bg-grey-300',
      grey400: 'bg-grey-400',
      grey500: 'bg-grey-500',
      grey600: 'bg-grey-600',
      grey700: 'bg-grey-700',

      brandDark: 'bg-brand-dark',
      brandDarkTransparent: 'border-brand-dark-50',
      brandLight: 'bg-brand-light',
      brandLime: 'bg-brand-lime',
      uiDark: 'bg-ui-dark',
      uiDarkMedium: `bg-ui-dark/70`,
      uiDarkDisabled: `bg-ui-dark/30`,
      uiLight: 'bg-ui-light',
      uiLightMedium: `bg-ui-light/70`,
      uiLightDisabled: `bg-ui-light/30`,
      uiGreyDark: 'bg-ui-grey',
      uiGreyMedium: 'bg-ui-grey-500',
      uiGreyLight: 'bg-ui-grey-50',
      uiGrayUltralight: 'bg-ui-grey-ultra-light',
      uiGreen: 'bg-ui-green',
      uiGreenLight: 'bg-ui-green-light',
      uiGreenMuted: 'bg-ui-green-500',
      uiGreenOverlay: 'bg-ui-green-overlay',
      uiRed: 'bg-ui-red',
      uiRedLight: 'bg-ui-red-light',
      uiRedMuted: 'bg-ui-red-500',
      uiOrange: 'bg-ui-orange',
      uiOrangeLight: 'bg-ui-orange-light',
      uiOrangeMuted: 'bg-ui-orange-500',
      blueSky: 'bg-blue-sky',
      playground1Dark: 'bg-playground1-dark',
      playground1Light: 'bg-playground1-light',
      playground2Dark: 'bg-playground2-dark',
      playground2Light: 'bg-playground2-light',
      playground3Dark: 'bg-playground3-dark',
      playground3Light: 'bg-playground3-light',
      playground4Dark: 'bg-playground4-dark',
      playground4Light: 'bg-playground4-light',
      playground5Dark: 'bg-playground5-dark',
      playground5Light: 'bg-playground5-light',
      playground6Dark: 'bg-playground6-dark',
      playground6Light: 'bg-playground6-light',
      whatsapp: 'bg-whatsapp',
      transparent: 'bg-transparent',
      backdrop: `bg-[${COLOR.backdrop}]`,
    },
  },
})

export const borderColor = tv({
  variants: {
    color: {
      white: 'border-white',
      black: 'border-black',

      paleSpring: 'border-pale-spring',
      paleSpringLight: 'border-pale-spring-light',
      paleSpringDark: 'border-pale-spring-dark',

      safepointsGreenLight: 'border-safepoints-green-light',

      deepForest: 'border-deep-forest',
      deepForestLight: 'border-deep-forest-light',
      deepForestDark: 'border-deep-forest-dark',

      success: 'border-success',
      successLight: 'border-success-light',
      successDark: 'border-success-dark',

      error: 'border-error',
      errorLight: 'border-error-light',
      errorDark: 'border-error-dark',

      warning: 'border-warning',
      warningLight: 'border-warning-light',
      warningDark: 'border-warning-dark',

      grey100: 'border-grey-100',
      grey200: 'border-grey-200',
      grey300: 'border-grey-300',
      grey400: 'border-grey-400',
      grey500: 'border-grey-500',
      grey600: 'border-grey-600',
      grey700: 'border-grey-700',

      brandDark: 'border-brand-dark',
      brandDarkTransparent: 'border-brand-dark-50',
      brandLight: 'border-brand-light',
      brandLime: 'border-brand-lime',
      uiDark: 'border-ui-dark',
      uiDarkMedium: `border-ui-dark/70`,
      uiDarkDisabled: `border-ui-dark/30`,
      uiLight: 'border-ui-light',
      uiLightMedium: `border-ui-light/70`,
      uiLightDisabled: `border-ui-light/30`,
      uiGreyDark: 'border-ui-grey',
      uiGreyMedium: 'border-ui-grey-500',
      uiGreyLight: 'border-ui-grey-50',
      uiGrayUltralight: 'border-ui-grey-ultra-light',
      uiGreen: 'border-ui-green',
      uiGreenLight: 'border-ui-green-light',
      uiGreenOverlay: 'border-ui-green-overlay',
      uiGreenMuted: 'border-ui-green-500',
      uiRed: 'border-ui-red',
      uiRedLight: 'border-ui-red-light',
      uiRedMuted: 'border-ui-red-500',
      uiOrange: 'border-ui-orange',
      uiOrangeLight: 'border-ui-orange-light',
      uiOrangeMuted: 'border-ui-orange-500',
      blueSky: 'border-blue-sky',
      playground1Dark: 'border-playground1-dark',
      playground1Light: 'border-playground1-light',
      playground2Dark: 'border-playground2-dark',
      playground2Light: 'border-playground2-light',
      playground3Dark: 'border-playground3-dark',
      playground3Light: 'border-playground3-light',
      playground4Dark: 'border-playground4-dark',
      playground4Light: 'border-playground4-light',
      playground5Dark: 'border-playground5-dark',
      playground5Light: 'border-playground5-light',
      playground6Dark: 'border-playground6-dark',
      playground6Light: 'border-playground6-light',
      whatsapp: 'border-whatsapp',
      transparent: 'border-transparent',
      backdrop: `border-[${COLOR.backdrop}]`,
    },
  },
})
